import { Injectable } from '@angular/core';
import { SYSParams } from './sys-params';
import { Http, Response, Headers, RequestOptions, RequestMethod } from '@angular/http';
import { Config } from '../../config/config';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';

@Injectable()
export class SYSParamsService {
    controller:string = 'Systems';
    constructor(private http: Http) { }
   
   
    GetList(Loai:string) {
        let headers = new Headers();
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {Loai:Loai};
        return this.http.post(Config.apiUrl + this.controller+'/GetListSYSParams', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
               
    }
    /*
    GetListFromPagination(idTinhThanh: number, paging:number,maxSize:number, keyword: string) {
        let headers = new Headers();
        let currentPage = paging - 1;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ '/GetListPagination?idTinhThanh=' + idTinhThanh + "&currentPage="+ currentPage+"&maxSize="+ maxSize + "&keyword=" + keyword, { headers: headers }).map(resp => resp.json());       
    }

    GetItem(id:number) {
        let headers = new Headers();
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {Id:id};
        return this.http.post(Config.apiUrl + this.controller+'/GetItem/'+id, JSON.stringify(data), { headers: headers }).map(resp => resp.json());
               
    }

    Save(item:SYSParams) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Delete(id) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            Id: id
        };
        return this.http.post(Config.apiUrl + this.controller+'/delete', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }*/
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/sys-params/sys-params.service.ts